import ReactGA from 'react-ga4';

// GA4 rejects events whose name is longer than 40 characters, so codes that embed
// ids (member, order) are truncated and reported instead of silently disappearing.
const GA_EVENT_NAME_MAX_LENGTH = 40;

export const sendGAEvent = (
  accountName: string | undefined | null,
  code: string | null,
  label: string,
): void => {
  if (!accountName || !code) {
    return;
  }

  const action = `${code}_${accountName.toUpperCase()}`;

  if (action.length > GA_EVENT_NAME_MAX_LENGTH) {
    console.warn(`GA event name exceeds ${GA_EVENT_NAME_MAX_LENGTH} characters and will be truncated: ${action}`);
  }

  ReactGA.event({
    category: accountName,
    action: action.substring(0, GA_EVENT_NAME_MAX_LENGTH),
    label,
    nonInteraction: false,
  });
};
